import request from '@/utils/request';

// 登录
export function Login(data) {
    return request({
        url: '/adapt/login',
        method: 'POST',
        data
    });
}

// 获取汉字点选验证码
export function QueryClickCaptcha() {
    return request({
        url: '/adapt/login/clickCaptcha',
        method: 'GET'
    });
}

// 校验汉字点选验证码
export function VerifyClickCaptcha(data) {
    return request({
        url: '/adapt/login/verifyClickCaptcha',
        method: 'POST',
        data
    });
}
